import { render } from "./registrationInstitutionDetails.vue?vue&type=template&id=9cfaf82c&scoped=true"
import script from "./registrationInstitutionDetails.vue?vue&type=script&lang=js"
export * from "./registrationInstitutionDetails.vue?vue&type=script&lang=js"

import "./registrationInstitutionDetails.vue?vue&type=style&index=0&id=9cfaf82c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cfaf82c"]])

export default __exports__